// @ts-nocheck
import React, { useState } from "react"
import styles from "./styles"

import { FormControl, OutlinedInput } from "@mui/material"
import { InputLabel, FormHelperText } from "@mui/material"

export default function InputText(props) {
	const { label, value, setValue, onChange, onBlur, sx,readOnly,disabled,errorText } = props
	const [helperText, setHelperText] = useState(() => "")

	function handleChange(event) {
		const value = event.target.value

		setValue(value)
		if (onChange) onChange({ value })
	}

	function handleBlur(event) {
		const value = event.target.value

		const error = validateText(value)
		if (onBlur) onBlur({ value, error })
	}

	function validateText(value) {
		const regex = /^[\w\d\s,.:&/'"-?+@]*$/;

		let error = ""
		if (!regex.test(value)) error = "Only valid characters are allowed (letters numbers . , - _ : / & ? + @)"

		setHelperText(error)
		return error
	}

	return (
		<FormControl variant="outlined" sx={{ ...styles.container, ...sx }}>
			<InputLabel htmlFor={`input-text-${label}`} sx={styles.label}>
				{label}
			</InputLabel>

			<OutlinedInput
				id={`input-text-${label}`}
				label={label}
				type="text"
				value={value}
				readOnly={readOnly}
        		disabled={disabled}
				onChange={handleChange}
				inputProps={{ onBlur: handleBlur }}
				sx={styles.input(value,errorText)}
			/>
      		{/* {Boolean(errorText) && <FormHelperText sx={styles.errorText}>{errorText}</FormHelperText>} */}
			{(Boolean(helperText) || Boolean(errorText)) && <FormHelperText sx={styles.helperText}>{helperText || errorText}</FormHelperText>}
		</FormControl>
	)
}
